// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1j0Ks","content":"LoadingAlert_content__AAgyS"};